import { CheckCircle } from 'lucide-react';

const FEATURE_IMG = "https://static.prod-images.emergentagent.com/jobs/eb0b6cb2-5b67-4a48-8f09-a50dd555aaf3/images/e3e6c104bce83b6c3eaf5967953c4149f51f9bf4f330ad5a067e949c455ef1f3.png";

const highlights = [
  "Unbiased fault analysis with percentages",
  "Personalised feedback for each party",
  "Actionable resolution steps",
  "AI relationship counsellor included",
  "Available on iOS, Android & Web",
];

export const FeatureSection = () => (
  <section className="py-20 sm:py-28" data-testid="feature-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        <div>
          <span className="text-xs uppercase tracking-[0.2em] font-sans font-semibold text-primary">Fair & Balanced</span>
          <h2 className="mt-3 text-2xl sm:text-3xl lg:text-4xl tracking-tight font-serif font-bold">
            AI That Understands Both Sides
          </h2>
          <p className="mt-4 text-muted-foreground leading-relaxed">
            Our advanced AI analyses the nuances of each argument, considers emotional context, and delivers a verdict that both parties can trust.
          </p>
          <ul className="mt-6 space-y-3">
            {highlights.map((item) => (
              <li key={item} className="flex items-start gap-3">
                <CheckCircle className="h-5 w-5 text-secondary mt-0.5 shrink-0" />
                <span className="text-sm">{item}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="relative">
          <img src={FEATURE_IMG} alt="Resolution" className="rounded-2xl w-full shadow-lg" />
        </div>
      </div>
    </div>
  </section>
);
